import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot, CanActivateChild } from '@angular/router';
import { AuthenticationService } from '@app/services/authentication.service';

const routes = [
    { page: 'Investigate Visualizer', route: '/home/search' },
    { page: 'Dashboard', route: '/home/dashboard' },
    { page: 'Candidate Screening', route: '/home/candidate' },
    { page: 'VDD Onboarding', route: '/home/compliance/vdd-onboarding' },
    { page: 'Vendor Onboarding', route: '/home/compliance/vendoronboarding' },
    { page: 'VDD', route: '/home/compliance/vdd' },
    { page: 'Vendors', route: '/home/compliance/vendors' },
    { page: 'PDD', route: '/home/compliance/pdd' },
    { page: 'Cash Cage', route: '/home/compliance/cashcage' },
    { page: 'Patrons List', route: '/home/patrons' },
    // { page: 'Employees', route: '/home/employees' },
    { page: 'Security', route: '/home/compliance/security' },
    { page: 'ThirdParty', route: '/home/compliance/third-party' },
    { page: 'Batch Screening', route: '/home/batch-screening' },
    { page: 'Consumer Account Opening', route: '/home/account-opening/personal' },
    { page: 'Commercial Account Opening', route: '/home/account-opening/business' },
    { page: 'ID Verification', route: '/home/inline-assessment' },
    { page: 'Assessment Order', route: '/home/assessment-order' },
    { page: 'Users', route: '/home/setup/accesscontrol' },
    { page: 'Permissions', route: '/home/setup/accesscontrol' },
    { page: 'Roles', route: '/home/setup/accesscontrol' },
    { page: 'Flow Rules', route: '/home/admin/flows' },
    { page: 'Data Loader', route: '/home/data-loader' },
    { page: 'Email', route: '/home/verification-mail' },
    { page: 'Index Mapping', route: '/home/index-mapping' },
    { page: 'Gestion de Reportes', route: '/home/gestion-reportes' },
    { page: 'Exclusion', route: '/home/exclusion' },
    { page: 'Audit Log', route: '/home/auditLog' }
];

const findRouteByPath = (path => {
    return routes.filter(route => route.route === path);
});
const findRouteByPage = (page => {
    return routes.filter(route => route.page === page);
});

function getFullRoutePath(snapshot: ActivatedRouteSnapshot): string {
    const segments: string[] = [];
  
    let current = snapshot;
    while (current) {
      if (current.routeConfig && current.routeConfig.path) {
        segments.unshift(current.routeConfig.path);
      }
      current = current.parent;
    }
  
    return '/' + segments.join('/');
}

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
    constructor(private _router: Router, private _authenticationService: AuthenticationService) {}

    canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
        return this.checkAuthentication();
    }

    checkAuthentication(): boolean {
        if (this._authenticationService.isLoggedIn) {
            return true;
        }

        this._router.navigate(['/login']);
        return false;
    }

    canAccessPath(childRoute: ActivatedRouteSnapshot): boolean {
        
        let currentPath = getFullRoutePath(childRoute);
        const currentRoutes = findRouteByPath(currentPath);

        if (currentPath.includes(':')) {
            currentPath.match(/:\w+/g).forEach(param => {
                // console.log('param:', param);
                // console.log('childRoute.paramMap:', childRoute.paramMap);
                const paramValue = childRoute.paramMap.get(param.substring(1));
                // console.log('paramValue:', paramValue);
                currentPath = currentPath.replace(param, paramValue);
            })
        }

        let hasAccess = currentRoutes.length == 0; // No routes found means no restrictions
        for (const route of currentRoutes) {
            hasAccess = this._authenticationService.hasAccess(route.page);
            if (hasAccess) {
                break;
            }
        }

        // console.log('Current Path:', currentPath);
        // console.log('Has Access:', hasAccess);
        // console.log('Current Route:', currentRoutes);

        if (hasAccess) {
            return true;
        }

        const pages = this._authenticationService.getAllowedPages();

        // console.log('Allowed Pages:', pages);

        const searchPage = pages.find(page => page === 'Investigate Visualizer');
        if (searchPage) {
            this._router.navigate(['/home/search']);
            return true;
        }
        
        const routes = findRouteByPage(pages[0]);
        if (routes && routes.length > 0) {
            const route = routes[0];
            const redirectPath = route.route;
            // console.log('Redirecting to:', redirectPath);
            this._router.navigate([redirectPath]);
            return true;
        }

        return false;
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
        return this.checkAuthentication() && this.canAccessPath(childRoute);
    }
}
